import { Box, styled } from "@mui/material";
export const TruffleModalActions = styled(Box)({
    display: "flex",
    flexDirection: "row",
    paddingBlockStart: "16px",
    justifyContent: "end",
    alignItems: "center",
    gap: "8px"
});
//# sourceMappingURL=TruffleModalActions.js.map